<template>
  <div>
    <SubFactorExcelFilter @exportExcel="exportExcel" />
    <page-title class="mt-2" title_text="لیست درخواست های اکسل تراکنش های"></page-title>
    <kt-datatable ref="excelDatatable" v-bind="excelDatatable"></kt-datatable>
  </div>
</template>

<script>

import { AuthorizationHeader } from '../../common/jwt.service';
import { ApiUrl, onlineFactorService } from '../../common/api.service';
import $ from 'jquery';
import SubFactorExcelFilter from '@/views/online-factor/components/sub-factor-excel-filter.vue';
import { KTApp } from '../../plugins/core/app';
import PageTitle from '../../components/main/components/pageTitle.vue';
import excelRequestColumn from '@/views/online-factor/datatable/columns_sub_factor_excel_requests';
import toastr from 'toastr';


export default {
  name: 'SubFactorExcel',
  components: {
    PageTitle,
    SubFactorExcelFilter
  },
  data() {
    return {
      factor_id: this.$route.params.hashid,
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };
      return toastr;
    },
    excelDatatable() {
      return {
        id: 'excelDatatable',
        data: {
          type: 'remote',
          source: {
            read: {
              url: ApiUrl.path(`factor/${this.factor_id}/excel-request`),
              method: 'GET',
              headers: AuthorizationHeader,
              map: function(res) {
                return res.data.data
              },
              params: this.query,
            }
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {},
        pagination: false,
        sortable: true,
        columns: excelRequestColumn,
      }
    },
  },
  methods: {
    exportExcel(query) {
      let btn = $("#export_excel");
      KTApp.progress(btn);

      const exportQuery = {
        ...{
          from_date: query.from_date,
          to_date: query.to_date,
          status: query.status,
          customer_fullname: query.customer_fullname,
        },
      };
      onlineFactorService
          .createSubFactorExcel(this.factor_id, exportQuery)
          .then((response) => {
            this.toastr.success(response.data.message);
            this.$refs.excelDatatable.reload();

            KTApp.unprogress(btn);
          })
          .catch(({ response }) => {
            this.toastr.error(response.data.message);
            KTApp.unprogress(btn);
          });
    },
  }
};
</script>

<style scoped>

</style>